import React from 'react';
import FormControl from '@material-ui/core/FormControl/FormControl';
import TextField from '@material-ui/core/TextField/TextField';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import InCardTextFieldWrapper from 'hcla-web-frontend-primitives/app/components/primitives/TextField/InCardTextFieldWrapper';

const styles = theme => ({
  formControl: {
    display: 'flex',
    flexDirection: 'row',
  },

  leftChild: {
    marginRight: `${theme.spacing.unit / 2}px`,
  },

  rightChild: {
    marginLeft: `${theme.spacing.unit / 2}px`,
  },

  fieldContainer: {
    border: '1px solid #ccc',
    background: '#f5f5f5',
    borderRadius: '4px',
    padding: '8px',
  },

});

const FourNumberFields = (props) => {
  const { disable } = props;
  const getPropVals = () => {
    const v = props.selected;
    try {
      return [v[0], v[1], v[2], v[3]];
    } catch (e) {
      return [NaN, NaN, NaN, NaN];
    }
  };

  const onChange = (event, value, idx) => {
    const newValue = Number(value);
    const values = getPropVals();
    values[idx] = newValue;
    props.onUpdate(event, 0, values);
  };

  const values = getPropVals();
  return (
    <div className={props.classes.fieldContainer}>
      <FormControl noValidate autoComplete="off">
        <div className={props.classes.formControl}>
          <div className={props.classes.leftChild}>
            <InCardTextFieldWrapper>
              <TextField
                autoFocus
                label={props.labels.first}
                type="number"
                margin="dense"
                value={values[0]}
                onChange={e => onChange(e, e.target.value, 0)}
                disabled={disable && disable.values}
              />
            </InCardTextFieldWrapper>
          </div>
          <div className={props.classes.rightChild}>
            <InCardTextFieldWrapper>
              <TextField
                label={props.labels.second}
                type="number"
                margin="dense"
                value={values[1]}
                onChange={e => onChange(e, e.target.value, 1)}
                disabled={disable && disable.values}
              />
            </InCardTextFieldWrapper>
          </div>
        </div>
        <div className={props.classes.formControl}>
          <div className={props.classes.leftChild}>
            <InCardTextFieldWrapper>
              <TextField
                autoFocus
                label={props.labels.third}
                type="number"
                margin="dense"
                value={values[2]}
                onChange={e => onChange(e, e.target.value, 2)}
              />
            </InCardTextFieldWrapper>
          </div>
          <div className={props.classes.rightChild}>
            <InCardTextFieldWrapper>
              <TextField
                label={props.labels.fourth}
                type="number"
                margin="dense"
                value={values[3]}
                onChange={e => onChange(e, e.target.value, 3)}
              />
            </InCardTextFieldWrapper>
          </div>
        </div>
      </FormControl>
    </div>
  );
};

FourNumberFields.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  onUpdate: PropTypes.instanceOf(Function).isRequired,
  labels: PropTypes.shape({
    first: PropTypes.string.isRequired,
    second: PropTypes.string.isRequired,
    third: PropTypes.string.isRequired,
    fourth: PropTypes.string.isRequired,
  }).isRequired,
  selected: PropTypes.arrayOf(Number).isRequired,
};

export default withStyles(styles)(FourNumberFields);
